module.exports = __webpack_public_path__ + "static/media/email-not-found.270fa69e.svg";